import React from "react";
import { useParams } from 'react-router-dom';
import CallItem from "./CallItem";
import {
  Icon,
  Table,
  Ref
} from "semantic-ui-react";
import "../CallPlayer.css";
import { useGetTalkgroupsQuery } from '../../features/api/apiSlice'

// ----------------------------------------------------
// Rendering only - everything to do with scrolling lives in useLiveScroll,
// which finds rows through the listRef handed down from CallPlayer.
const ListCalls = (props) => {
  const { shortName } = useParams();
  const activeCallId = props.activeCallId;
  const callsData = props.callsData;
  const { data: talkgroupsData } = useGetTalkgroupsQuery(shortName);

  return (
    <Ref innerRef={props.listRef}>
      <Table id="calls" unstackable  >
        <Table.Header >
          <Table.Row>
            <Table.HeaderCell> </Table.HeaderCell>
            <Table.HeaderCell>Len</Table.HeaderCell>
            <Table.HeaderCell>Talkgroup</Table.HeaderCell>
            <Table.HeaderCell>Tag</Table.HeaderCell>
            <Table.HeaderCell>Time</Table.HeaderCell>
            <Table.HeaderCell><Icon name='star' /></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {callsData &&
          <Table.Body>
            {
              callsData.ids.map((callId) => (
                <CallItem
                  key={callId}
                  activeCall={callId === activeCallId}
                  call={callsData.entities[callId]}
                  talkgroups={talkgroupsData}
                  onClick={props.playCall}
                />
              ))
            }
          </Table.Body>
        }
      </Table>
    </Ref>
  );

}

export default ListCalls;
